module.exports = __webpack_public_path__ + "static/media/fleet2.e56fe6d2.jpg";